module.exports = __webpack_public_path__ + "img/IMG_1539_Mockup.1eca48de.jpg";